import Serializable from '../../interfaces/serializable'

export default class SentryConfig implements Serializable<SentryConfig> {
  dsn!: string

  deserialize (input: any) {
    this.dsn = input.dsn

    return this
  }
}
